import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const VisibilityIconsFilter = ({filterByOwner, filterByClientsOrCommunity, isActiveOwner, isActiveClients, isActiveCommunity}) => {

  const iconsStructure = [
    {
      iconToRender: ["far", "lock"],
      onClick: filterByOwner,
      isActive: isActiveOwner
    },
    {
      iconToRender: ["far", "portrait"],
      onClick: filterByClientsOrCommunity,
      isActive: isActiveClients
    },
    {
      iconToRender: ["far", "globe"],
      onClick: filterByClientsOrCommunity,
      isActive: isActiveCommunity
    }
  ];

  const icons = iconsStructure.map((icon, index) => {
    return <FontAwesomeIcon
      className="askEdit-chooseTemplate-filter-icon"
      style={{color: icon.isActive ? "rgb(0, 144, 209)" : "#5a6872"}}
      key= {index}
      icon={icon.iconToRender}
      onClick={() => icon.onClick(index)}
    />;
  });

  return (
    <div>
      {icons}
    </div>
  );
};

export default VisibilityIconsFilter;